"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PELICAN_FUNCTIONAL_ENHANCEMENT_STYLE_COLORS = exports.makePelicanStyleColors = exports.Style = exports.CoverImage = void 0;
const effect_1 = require("effect");
const color_1 = require("../../../../../../color");
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition.Enhancement.Style';
const Colors = effect_1.Schema.Record({
    key: effect_1.Schema.Literal('lightest', 'lighter', 'light', 'normal', 'dark', 'darker', 'darkest', 'foreground', 'text'),
    value: effect_1.Schema.NullOr(color_1.HexColor),
}).annotations({ identifier: `${NAMESPACE}.Colors` });
exports.CoverImage = effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString).annotations({
    identifier: `${NAMESPACE}.CoverImage`,
    arbitrary: () => fc => fc.constantFrom('https://picsum.photos/200'),
});
exports.Style = effect_1.Schema.Struct({
    colors: Colors,
    coverImage: exports.CoverImage,
}).annotations({ identifier: `${NAMESPACE}.Style` });
const makePelicanStyleColors = ({ light, dark, text, }) => Colors.make({
    lightest: null,
    lighter: null,
    light,
    normal: null,
    dark,
    darker: null,
    darkest: null,
    foreground: null,
    text,
});
exports.makePelicanStyleColors = makePelicanStyleColors;
const FUNCTIONAL_PURPLE = effect_1.Schema.decodeSync(color_1.HexColor)('#8256FF');
exports.PELICAN_FUNCTIONAL_ENHANCEMENT_STYLE_COLORS = (0, exports.makePelicanStyleColors)({
    light: FUNCTIONAL_PURPLE,
    dark: FUNCTIONAL_PURPLE,
    text: FUNCTIONAL_PURPLE,
});
//# sourceMappingURL=style.js.map